import crypto from 'crypto';
import { Buffer } from 'buffer';

// https://stackoverflow.com/questions/2670037/how-to-remove-invalid-utf-8-characters-from-a-javascript-string
// codes from 0 to 31 are ASCII Nonprintable Characters (they are fine for browser, but JSON.parse doesn't like them)
// https://condor.depaul.edu/sjost/lsp121/documents/ascii-npr.htm
function cleanStringFromSpecialChars(input: string) {
  var output = '';
  for (var i = 0; i < input.length; i++) {
    if (input.charCodeAt(i) > 31 && input.charCodeAt(i) <= 127) {
      output += input.charAt(i);
    }
  }
  return output;
}

export function encrypt(stringToEncrypt: string, secret: string, salt: string): string | null {
  try {
    const resizedIV = Buffer.allocUnsafe(16);
    const iv = crypto.createHash('sha256').update(`${secret}${salt}`).digest();
    iv.copy(resizedIV);

    const key = crypto.createHash('sha256').update(secret).digest();
    const cipher = crypto.createCipheriv('aes256', key, resizedIV);
    const msg = [];
    msg.push(cipher.update(stringToEncrypt, 'binary', 'hex'));
    msg.push(cipher.final('hex'));
    return msg.join('');
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export function decrypt(hashedString: string, secret: string, salt: string): string | null {
  try {
    const resizedIV = Buffer.allocUnsafe(16);
    const iv = crypto.createHash('sha256').update(`${secret}${salt}`).digest();
    iv.copy(resizedIV);

    const key = crypto.createHash('sha256').update(secret).digest();

    const decipher = crypto.createDecipheriv('aes256', key, resizedIV);
    const msg = [];
    msg.push(decipher.update(hashedString, 'hex', 'binary'));
    msg.push(decipher.final('binary'));

    return cleanStringFromSpecialChars(msg.join(''));
  } catch (err) {
    console.error(err);
    throw err;
  }
}
